"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../../comps/reusables");
const ButtonContainer_1 = require("../ButtonContainer");
const react_2 = require("@osmosys/react");
exports.EmailCanvasBlockUploadButton = ({ contentCanBeChanged, updateBlock, }) => {
    const disabled = !contentCanBeChanged;
    return (react_1.default.createElement(reusables_1.FileUploader, { onUpload: hostedFile => {
            updateBlock({
                contentFeed: null,
                contentFieldKey: null,
                contentItem: null,
                contentSlotNumber: null,
                contentStr: hostedFile.url,
            });
        }, disabled: disabled }, (open, result, successBuffer) => {
        return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
            react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { osysName: "EmailCanvasBlockLockButton", blurOnClick: true, iconSpin: result.loading, osysIcon: result.loading
                    ? 'spinner'
                    : successBuffer
                        ? 'success'
                        : 'upload', disabled: disabled || result.loading || successBuffer, tooltip: "Upload photo", onClick: () => {
                    if (disabled) {
                        return;
                    }
                    open();
                } }, successBuffer
                ? 'Upload successful'
                : result.loading
                    ? 'Uploading...'
                    : '')));
    }));
};
//# sourceMappingURL=UploadButton.js.map